const DownArrowIcon = ({ className }: { className?: string }) => (
	<svg
		className={className}
		fill='currentColor'
		height='6'
		viewBox='0 0 10 6'
		width='10'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			clip-rule='evenodd'
			d='M0.813195 0.813073C0.617933 1.00833 0.617933 1.32492 0.813195 1.52018L4.97986 5.68685C5.17512 5.88211 5.49171 5.88211 5.68697 5.68685L9.85363 1.52018C10.0489 1.32492 10.0489 1.00833 9.85363 0.813073C9.65837 0.61781 9.34179 0.61781 9.14653 0.813073L5.33342 4.62619L1.5203 0.813073C1.32504 0.61781 1.00846 0.61781 0.813195 0.813073Z'
			fill='currentColor'
			fill-rule='evenodd'
		/>
	</svg>
)

export { DownArrowIcon }
